<script>
/*jshint esversion: 6 */
import { computed, watch, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
export default {
    name: 'MyText',
    props: {
        'disabled': {type: Boolean},
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep:true});

        function getDataTitle() {
            var fileArr = [];
            if (props.model.newFile === true) {
                props.model.files.forEach(element => {
                    var fileSplit = element.split('_');
                    fileArr.push(fileSplit[fileSplit.length-1]);
                });
                if (fileArr.includes('EDIT.pdf')) {
                    props.model.wnWebsiteType = 'EDIT';
                    return `${props.model[props.schema.webSiteDoc]}_EDIT.pdf`;
                } else {
                    props.model.wnWebsiteType = 'WEB';
                    return `${props.model[props.schema.webSiteDoc]}_WEB.pdf`;
                }
            } else {
                return `<span class="red">Achtung! Da sie keine neuen Dateien hochladen, findet kein Upload zu ${props.schema.url} statt!</span>`;
            }
        }

        return {
            getDataTitle
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldWebServiceData(:id="schemaId" :class="[schema.class, disabled === true ? 'fieldDisabled': '']")
        label(v-if="schema.label && schema.label.length > 0") {{ schema.label }}
        br
        div(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed': ''")
            ul 
                li( v-html="getDataTitle()")
            br
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}

</template>